// Build-time feature toggles. REACT_APP_* values are baked in at build time,
// so flipping one needs a rebuild + redeploy.

// Digio e-sign on the onboarding T&C step. Off by default (Digio credits
// exhausted, Sept 2026) — members accept T&C with the checkbox only. Set
// REACT_APP_DIGIO_ENABLED=true to bring back the Digio signing flow.
export const DIGIO_ENABLED = process.env.REACT_APP_DIGIO_ENABLED === "true";
